import React, { useState, useEffect } from 'react';
import Validation from './ValidateForm';
import Axios from 'axios';
import { useHistory } from "react-router-dom";
import Loader from "../user/Loader";


const Form = () => {
    localStorage.removeItem("successfulReservationToken");
    const [open, setOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [list_of_locations, setLocation] = useState([]);
    const [list_of_services, setService] = useState([]);
    const [formData, setFormData] = useState({
        Surname: "",
        MatricNo: "",
        Department: "",
        LocationId: null,
        PhoneNumber: "",
        OtherName: "",
        Email: "",
        ServiceId: null,
        Whatsapp: null,
        PreferredTimeSlot: "",

    });
    let history = useHistory();

    //this method fetched the the list of services and campus locations
    const fetchData = () => {
        const serviceApi = process.env.REACT_APP_BASEURL + process.env.REACT_APP_SERVICE_LIST_URL;
        const locationApi = process.env.REACT_APP_BASEURL + process.env.REACT_APP_CAMPUS_LIST_URL;

        const getServices = Axios.get(serviceApi);
        const getlocations = Axios.get(locationApi);

        Axios.all([getServices, getlocations])
            .then(
                Axios.spread((...Data) => {
                    const services = Data[0];
                    const locations = Data[1];
                    setService(services.data);
                    setLocation(locations.data);

                })
            )
    }


    //this stores the input field values when its been modified
    const handleInputChange = (event) => {
        event.preventDefault();
        let name = event.target.name;
        if (name === "ServiceId") {
            setFormData({
                ...formData, [name]: parseInt(event.target.value)
            })
        }
        else if (name === "LocationId") {
            setFormData({
                ...formData, [name]: parseInt(event.target.value)
            })
        }
        else {
            setFormData({
                ...formData, [name]: event.target.value
            })
        }
    }

    //this is used to get the values when the radio buttons are checked
    const handleOnCheck = (event) => {

        if (event.target.id === "no") {
            setFormData({
                ...formData, [event.target.name]: false
            })
        }
        else if (event.target.id === "yes") {
            setFormData({
                ...formData, [event.target.name]: true
            })
        }
        else {
            setFormData({
                ...formData,
                [event.target.name]: event.target.value
            })
        }
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    //this is called when the submit button is clicked
    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors(Validation(formData));
        let formIsValidated = Validation(formData).isValidated;

        if (formIsValidated) {
            handleToggle();
            const reservationApi = process.env.REACT_APP_BASEURL + process.env.REACT_APP_ADD_RESERVATION_URL;

            Axios.post(reservationApi, formData)
                .then((response) => {
                    handleClose();
                    localStorage.setItem("successfulReservationToken", true);
                    history.push("/reservationSuccessful");
                })
                .catch(err =>{
                });
        }
        else {
            history.push("/form");
        }
    }
    useEffect(() => {
        fetchData();

    }, []);

    return (
        <div className="form-wrapper">
            <div className="form-container">
                <div className="form-inner-container">
                    <h1>RESERVATION FORM</h1>
                    <hr />
                    <div className="error-message-wrapper" style={formErrors.isValidated == false ? { display: "block" } : { display: "none" }}>
                        <p>Fill up all inputs correctly!!!</p>
                    </div>
                    <div className="input-wrapper">
                        <form onSubmit={handleSubmit}>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Surname"
                                    maxLength="30"
                                    className="input"
                                    name="Surname"
                                    onChange={handleInputChange}
                                />
                                {formErrors.surname && <p className="error">{formErrors.surname}</p>}
                            </div>

                            <div>
                                <input
                                    type="text"
                                    placeholder="Other Names"
                                    maxLength="30"
                                    className="input"
                                    name="OtherName"
                                    onChange={handleInputChange}
                                />
                                {formErrors.otherNames && <p className="error">{formErrors.otherNames}</p>}
                            </div>

                            <div>
                                <input
                                    type="text"
                                    placeholder="Phone Number"
                                    maxLength="30"
                                    className="input"
                                    name="PhoneNumber"
                                    onChange={handleInputChange}
                                />
                                {formErrors.phoneNumber && <p className="error">{formErrors.phoneNumber}</p>}
                            </div>

                            <div>
                                <input
                                    type="text"
                                    placeholder="Matriculation number"
                                    maxLength="30"
                                    className="input"
                                    name="MatricNo"
                                    onChange={handleInputChange}
                                />
                                {formErrors.matricNum && <p className="error">{formErrors.matricNum}</p>}
                            </div>

                            <div>
                                <input
                                    type="text"
                                    placeholder="Faculty/Department"
                                    maxLength="30"
                                    className="input"
                                    name="Department"
                                    onChange={handleInputChange}
                                />
                                {formErrors.department && <p className="error">{formErrors.department}</p>}
                            </div>

                            <div>
                                <select name="LocationId" id="campusLoc" className="select" onChange={handleInputChange}>
                                    <option>Campus Location</option>
                                    {list_of_locations.map(location => {
                                        return <option key={location.locationId} value={location.locationId}>{location.campusLocation}</option>
                                    })
                                    }
                                </select>
                                {formErrors.campusLoc && <p className="error">{formErrors.campusLoc}</p>}
                            </div>


                            <div>
                                <select name="ServiceId" id="services" className="select" onChange={handleInputChange}>
                                    <option>Select Service</option>
                                    {list_of_services.map(service => {
                                        return <option key={service.serviceId} value={service.serviceId}>{service.service_description}</option>
                                    })
                                    }
                                </select>
                                {formErrors.service && <p className="error">{formErrors.service}</p>}
                            </div>
                            <div>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    length="30"
                                    className="input"
                                    name="Email"
                                    onChange={handleInputChange}
                                />
                                {formErrors.email && <p className="error">{formErrors.email}</p>}
                            </div>
                            <div className="check-box-wrapper">
                                <div>
                                    <p>Is Phone Number on Whatsapp</p>
                                    <div>
                                        <input
                                            type="radio"
                                            name="Whatsapp"
                                            id="yes"
                                            className="checkbox"
                                            onClick={handleOnCheck}
                                        />
                                        <label htmlFor="yes">yes</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="Whatsapp"
                                            id="no"
                                            className="checkbox"
                                            onClick={handleOnCheck}
                                        />
                                        <label htmlFor="no">no</label>
                                    </div>
                                    {formErrors.numOnWhatsapp && <p className="error">{formErrors.numOnWhatsapp}</p>}
                                </div>

                                <div>
                                    <p>Select prefered time of Visit</p>
                                    <div>
                                        <input
                                            type="radio"
                                            name="PreferredTimeSlot"
                                            id="fisrt-session"
                                            value="8-10"
                                            className="fisrt-session"
                                            onClick={handleOnCheck}

                                        />
                                        <label htmlFor="fisrt-session">8AM - 10AM</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            value="10-12"
                                            name="PreferredTimeSlot"
                                            id="second-session"
                                            className="second-session"
                                            onClick={handleOnCheck}
                                        />
                                        <label htmlFor="second-session">10AM - 12PM</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            name="PreferredTimeSlot"
                                            value="12-14"
                                            id="thrid-session"
                                            className="third-session"
                                            onClick={handleOnCheck}
                                        />
                                        <label htmlFor="third-session">12PM - 2PM</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            name="PreferredTimeSlot"
                                            value="14-16"
                                            id="forth-session"
                                            className="forth-session"
                                            onClick={handleOnCheck}
                                        />
                                        <label htmlFor="forth-session">2PM - 4PM</label>
                                    </div>
                                    {formErrors.timeSlot && <p className="error">{formErrors.timeSlot}</p>}
                                </div>

                            </div>
                            <div class="form-button">
                                <button
                                    className="button"
                                    name="submit"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                                <Loader state={open} />
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default Form;